<template>
    <div>
        <!--　处理完成　-->
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" class="event-form">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="下一节点">
                        <span>处理完成</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="处理组" prop="currentDepartment">
                        <el-select v-model="form.currentDepartment" filterable placeholder="请选择" @change="departmentChange">
                            <el-option v-for="item in departmentList" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                        <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="处理人" prop="currentHandler">
                        <div class="el-form__inline">
                            <el-input v-model="form.currentHandler" disabled></el-input>
                            <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="解决方式" prop="solutionMode">
                        <el-select v-model="form.solutionMode" placeholder="请选择" >
                            <el-option v-for="item in solutionMode" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="原因" prop="solutionReason">
                        <el-select v-model="form.solutionReason" placeholder="请选择" >
                            <el-option v-for="item in solutionReason" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="解决标识" prop="solutionLabel">
                        <el-select v-model="form.solutionLabel" placeholder="请选择" >
                            <el-option v-for="item in solutionLabel" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="高危操作" prop="isHighRiskOperation">
                        <el-radio v-model="form.isHighRiskOperation" label="1">是</el-radio>
                        <el-radio v-model="form.isHighRiskOperation" label="0">否</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="解决方案">
                        <ueditor v-model="solutionComment" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                        <div>
                            <el-checkbox v-model="upKnowledge">解决方案保存到知识库</el-checkbox>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="upKnowledge">
                <el-col :span="12">
                    <el-form-item label="知识分类">
                        <el-select v-model="knowledgeClass" placeholder="请选择">
                            <el-option v-for="item in categoryList" :key="item.id" :label="item.title"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="知识关键字">
                        <el-input v-model="knowledgeKeyword"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="知会" >
                <div class="el-form__inline">
                    <notifyTab :data="form.notify" :getData="getNotifyData"></notifyTab>
                    <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                        <span  class="noticeAdd">+</span>
                    </router-link>
                </div>
            </el-form-item>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="附件">
                        <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import notifyTab from "../common/notifyTab.vue"
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";
    import ueditor from "../../components/ueditor.vue"
    import inputFile from "../common/inputFile.vue"
    import services from "./event.service"
    import commonService from "../../services/common.service"
    import { getRules } from "./event.rules";
    const rules = getRules();
    export default {
        props:{
            serialNumber:String,
            callback:Function
        },
        data() {
            return {
                rules:rules,
                form:{
                    currentDepartment:"",
                    currentHandler:'',
                    solutionMode:"",
                    solutionReason:"",
                    solutionLabel:"",
                    isHighRiskOperation: "0",
                    notify:[]
                },
                notifyUserid:[],

                knowledgeClass:"",
                solutionComment:"",
                upKnowledge:false,
                requesterInfo:{},
                departmentList:[],      // 处理组
                dis_user:true,
                attachment:[],
                knowledgeKeyword:"",
                categoryList:[],
                groupTasksTotal:'',   //组任务数
                userTasksTotal:'',    //人员任务数量
                isSubmit:false,
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    serverUrl:Config.BASE_API + "upload/",
                },
            }
        },
        components:{ ueditor,notifyTab,inputFile },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            solutionMode(){
                return this.dictionary.solution_mode;
            },
            solutionReason(){
                return this.dictionary.solution_reason;
            },
            solutionLabel(){
                return this.dictionary.solution_label;
            },
            knowledgeClassList(){
                return this.dictionary.solution_label;
            },
            // 知识分类id
            knowledgeType(){
                return this.$store.state.caseType.knowledge;
            }
        },
        created() {
            this.getDepartment();
            this.getCategoryList();
        },
        methods: {
            // 服务组
            getDepartment(){
                let params= {
                    departmentId:99999,
                    type:'group'
                }
                commonService.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;
                })
            },
            departmentChange(){
                this.dis_user = this.form.currentDepartment ? false : true;
                this.requesterInfo = {
                    id:"",
                    name:"",
                };

                let groupId=this.form.currentDepartment
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                services.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 获取知识分类
            getCategoryList(){
                commonService.categoryList(this.knowledgeType.id).then(res => {
                    this.categoryList = res;
                })
            },
            toRequesterList(){
                let id = this.form.currentDepartment.toString();
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:id
                    }
                })
            },

            // 获取选择的组员
            getRequester(obj){
                this.requesterInfo = {
                    id:obj.internalUserid,
                    name:obj.name,
                };
                this.form.currentHandler = obj.name;

                let userid=this.requesterInfo.id
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                   _this.solutionComment = editorInstance.getContent()
                });
            },
            submit(){
                this.isSubmit=true
                let params=this.getParams()
                if (this.upKnowledge&&(!this.knowledgeKeyword||!this.knowledgeClass)){
                        this.isSubmit=false
                        this.$message.error('知识分类或知识关键字不能为空！')
                } else {
                    this.$refs['form'].validate(valid=>{
                        if (valid){
                            if(!params.solutionComment){
                                this.isSubmit=false
                                this.$message.error('请填写解决方案')
                            }else{
                                services.handle(params).then(res => {
                                    this.$message.success("处理完成");
                                    this.close(true);
                                }).catch(err => {
                                    this.isSubmit=false
                                    this.$message.error(err.message)
                                })
                            }
                        } else{
                            this.isSubmit=false
                            this.$message.error('✳为必填项，请全部填写')
                        }
                    })

                }

            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr

            },
            getParams(){
                this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                let upKnowledge = this.upKnowledge ? "1" : "0";
                let params = {
                    ...this.form,
                    handle:"处理完成",
                    serialNumber:this.serialNumber,
                    currentHandler:this.requesterInfo.id,
                    solutionComment:this.solutionComment,
                    upKnowledge:upKnowledge,
                    attachment:this.attachment,
                    notify:this.notifyUserid
                };
                if(this.upKnowledge){

                    params.knowledgeKeyword = this.knowledgeKeyword.split(",");
                    params.knowledgeClass = this.knowledgeClass;
                }
                return params;
            },
            //上传附件
            getFiles(val){
                this.attachment = val;
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
